import { Injectable, InjectionToken, Provider } from '@angular/core';
import { ContextService } from 'projects/shared/lib/services/infrastructure/context/context.service';
import { IContextServiceToken } from 'projects/shared/lib/services/infrastructure/context/context-service.interface';

@Injectable({
  providedIn: 'root'
})
export class ContextMHService extends ContextService {

  isMyShopActive() {
    return this.contextGet().localeCompare('myShop') == 0;
  }

  public contextToggle() {
    let desiredContext = '';
    let contextCurrent = this.contextGet();
    switch (contextCurrent) {
      case '':
        desiredContext = 'myShop';
        break;

      case 'myShop':
        desiredContext = '';
        break;

      default:
        break;
    }
    this.contextSet(desiredContext);
    this.contextTriggerUiRefresh();
  }

}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const IContextMHServiceToken = new InjectionToken<ContextMHService>('IContextMHServiceToken');


/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ContextMHServiceProvider: Provider[] = [
  { provide: IContextServiceToken, useExisting: ContextMHService },
  { provide: IContextMHServiceToken, useExisting: ContextMHService }
];
